export const MyHomeExtAppApiUrl = window._env_.MYHOME_EXT_API_URL;

export const loginUrl = "/users/auth/login/";
export const logoutUrl = "/users/auth/logout/";
export const refreshTokenUrl = "/users/auth/refresh/";
export const aadLoginUrl = "/users/aad_auth/login/";

export const linkUrl = "links/link/";

